export default "__VITE_PUBLIC_ASSET__90d4d2d5__"